export default function (o) {
  Object.assign(o, {
    sendContactUsMessage (message) { return this.server.post('contact-us', message) },
    sendRequestAccessMessage (message) { return this.server.post('contact-us/request-access', message) },
  })
}
